/** Shared copy for surfaces that require an active company context. */

export const COMPANY_MENU_INSTRUCTION =
  'Click your avatar (top right) → open the account menu → choose a company under Select Company.';

export const COMPANY_MENU_INSTRUCTION_SHORT =
  'Open the account menu (avatar, top right) and pick a company under Select Company.';

export const COMPANY_CREATE_INSTRUCTION =
  'No company is linked to your account yet. Register with a company name or ask an admin to assign you to a company.';

export const COMPANY_UNREACHABLE_INSTRUCTION =
  'This workspace slug is not provisioned in kryspace on this server (manifest read failed). Ask an admin to reconcile roster ↔ slug registry, or create a new company.';

export const COMPANY_SELECTOR_ERROR_RECOVERY =
  'If every company fails to load, use Create company below or Reload list after an admin fixes slug mappings.';

export function companySelectionAlertDescription(options?: {
  includeCreateHint?: boolean;
  /** When true, companies exist but none is selected — do not imply account has none. */
  hasAvailableCompanies?: boolean;
}): string {
  if (options?.hasAvailableCompanies) {
    return COMPANY_MENU_INSTRUCTION_SHORT;
  }
  const parts = [COMPANY_MENU_INSTRUCTION_SHORT];
  if (options?.includeCreateHint) {
    parts.push(COMPANY_CREATE_INSTRUCTION);
  }
  return parts.join(' ');
}
